import { useState, useEffect } from 'react';

// Hooks
import useLanguage from '../useLanguage';

function useBenefits() {
  const [benefits, setBenefits] = useState([]);
  const { locale } = useLanguage();

  useEffect(() => {
    const getBenefits = async () => {
      const response = await fetch(`/api/bread/benefits/search?lang=${locale}`);
      const newBenefits = await response.json();
      if (response.status === 200) {
        setBenefits(newBenefits.results);
      }
    };
    getBenefits();
  }, []);

  return { benefits };
}

export default useBenefits;
